module.exports = __webpack_public_path__ + "static/media/2.9f4e2f0a.svg";